__turbopack_context__.v({
  "offerTileMenuButton": "styles-module__VlSVga__offerTileMenuButton",
  "offerTileMenuWrapper": "styles-module__VlSVga__offerTileMenuWrapper",
});
